module.exports = __webpack_public_path__ + "static/img/wechat-gzh.a956959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat-gzh.png
// module id = J5NA
// module chunks = 15